const apiEndPoint = 'https://maplestory.io/api'
const storeEndPoint = 'https://store.maplestory.io/api'

const Const = {
    apiEndPoint,
    storeEndPoint,
    apiRoot: () => `${apiEndPoint}/${Const.region()}/${Const.version()}`,
    region: () => 'GMS',
    version: () => '209.2.0'
}

export default Const